/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacilityScreenerSettingsEntry
 */
export interface FacilityScreenerSettingsEntry {
    /**
     * 
     * @type {string}
     * @memberof FacilityScreenerSettingsEntry
     */
    facility_id: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FacilityScreenerSettingsEntry
     */
    settings: { [key: string]: any; };
}

/**
 * Check if a given object implements the FacilityScreenerSettingsEntry interface.
 */
export function instanceOfFacilityScreenerSettingsEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "settings" in value;

    return isInstance;
}

export function FacilityScreenerSettingsEntryFromJSON(json: any): FacilityScreenerSettingsEntry {
    return FacilityScreenerSettingsEntryFromJSONTyped(json, false);
}

export function FacilityScreenerSettingsEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityScreenerSettingsEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'],
        'settings': json['settings'],
    };
}

export function FacilityScreenerSettingsEntryToJSON(value?: FacilityScreenerSettingsEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facility_id': value.facility_id,
        'settings': value.settings,
    };
}

